import React from 'react';
import Module from 'Components/Core/Module';
import useBrokerageConnections from 'Components/Banking/useBrokerageConnections';
import BrokerageLoginForm from 'Components/Banking/BrokerageLoginForm';
import './Brokerage.css';

// Muss (wie ModuleTable es intern tut) in <Module> gewrappt werden - nur das
// registriert bei x.wam[id].show()/hide() die tatsaechliche Ein-/Ausblende-
// Logik beim Seitenwechsel. Ohne diesen Wrapper bleibt die Seite dauerhaft im
// DOM sichtbar und ueberlappt beim Navigieren mit anderen Modulen.
export default function BrokerageOverview(props) {

	const x = props.x;
	const connections = useBrokerageConnections(x);

	const [connectionId, setConnectionId] = React.useState(null);
	const [loggedIn, setLoggedIn] = React.useState(false);
	const [depots, setDepots] = React.useState(null);
	const [error, setError] = React.useState('');

	// Bei genau einer comdirect-Verbindung direkt weiter, ohne unnoetige Auswahl.
	React.useEffect(() => {
		if (connectionId === null && connections && connections.length === 1) {
			setConnectionId(connections[0].connectionid);
		}
	}, [connections, connectionId]);

	function loadDepots() {
		x.was.axPost('Backend/webapp.php?module=Banking&task=BrokerageDepotList', { connectionId }, (result) => {
			const content = result.data.content || {};
			if (result.data.returncode !== 1) {
				if (content.status === 'login-required') {
					setLoggedIn(false);
					return;
				}
				setError(content.message || 'Depot konnte nicht geladen werden.');
				return;
			}
			setDepots(content.depots || []);
		});
	}

	React.useEffect(() => {
		if (loggedIn) loadDepots();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loggedIn]);

	const connection = connections ? connections.find((c) => c.connectionid === connectionId) : null;

	let inner;
	if (connections === null) {
		inner = <p>Lade…</p>;
	} else if (connections.length === 0) {
		inner = <p>Keine comdirect-Verbindung vorhanden. Bitte zuerst unter Banking → Konten eine comdirect-Verbindung anlegen.</p>;
	} else if (connectionId === null) {
		inner = (
			<div className="brokerage-picker">
				{connections.map((c) => (
					<div key={c.connectionid} className="brokerage-picker-item" onClick={() => setConnectionId(c.connectionid)}>
						{c.bankname} – {c.accountlabel}
					</div>
				))}
			</div>
		);
	} else if (!loggedIn) {
		inner = (
			<BrokerageLoginForm
				x={x}
				connectionId={connectionId}
				accountLabel={connection ? connection.bankname + ' – ' + connection.accountlabel : ''}
				pinUse={true}
				pinStored={connection ? parseInt(connection.pinstored, 10) === 1 : false}
				onLoggedIn={() => setLoggedIn(true)}
			/>
		);
	} else {
		inner = (
			<React.Fragment>
				{error !== '' && <p className="brokerage-error"><i className="bi bi-exclamation-triangle"></i> {error}</p>}
				{depots === null && <p>Lade Depot…</p>}
				{depots !== null && depots.length === 0 && <p>Kein Depot gefunden.</p>}
				{(depots || []).map((depot) => (
					<div key={depot.depotId} className="brokerage-depot">
						<div className="brokerage-depot-header">
							<strong>Depot {depot.depotDisplayId}</strong>
						</div>
						{(depot.positions || []).length === 0 && <p className="brokerage-hint">Keine Positionen.</p>}
						{(depot.positions || []).map((position, idx) => (
							<div key={idx} className="brokerage-position">
								<span>{(position.instrument && (position.instrument.name || position.instrument.wkn)) || position.instrumentId || 'Position'}</span>
								<span>{(position.quantity && position.quantity.value) || position.quantity || ''}</span>
							</div>
						))}
					</div>
				))}
			</React.Fragment>
		);
	}

	return (
		<Module id={props.id} x={x} classes="module-brokerage-overview" title={props.title} display="d-block">
			{inner}
		</Module>
	)

};
